import Helpers from '@assets/scripts/helpers';

const state = {
	showCreateNew: false,
	modified: false,
	canBeModified: false,
	currentScript: {},
};

export default () => Helpers.cloneObject(state);
